// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.enums.RentalManagerExternalTourType

export enum RentalManagerExternalTourType {
  FEED_PROVIDED = 'FEED_PROVIDED',
  INTEGRATION = 'INTEGRATION',
  ZRM = 'ZRM',
}

export const RentalManagerExternalTourType_values = [
  RentalManagerExternalTourType.FEED_PROVIDED,
  RentalManagerExternalTourType.INTEGRATION,
  RentalManagerExternalTourType.ZRM,
] as const;
